var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruefalseKnob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 45C12 26.7746 26.7746 12 45 12C63.2254 12 78 26.7746 78 45C78 63.2254 63.2254 78 45 78C26.7746 78 12 63.2254 12 45ZM40.8959 54.0818C40.1483 54.0773 39.5274 53.4483 39.5326 52.7008C39.5503 49.02 39.6689 47.5367 40.4064 45.7481C40.9985 44.4261 42.4803 42.8544 44.0609 41.178C47.3719 37.6662 51.1159 33.6951 48.0196 30.5988C47.2227 29.8018 46.1052 29.4129 44.9857 29.5429C42.2196 29.5429 41.1999 31.6642 40.9368 33.7595C40.8636 34.4555 40.2814 34.9867 39.5817 34.996H31.3639C30.5981 34.9898 29.9702 34.3311 30.0006 33.5659C30.3146 24.6584 36.3281 20 44.9857 20C50.038 20 53.2894 20.9543 55.8578 23.2091C64.2928 30.9443 58.2242 40.7381 51.6739 46.9723C50.0912 48.5186 49.1758 50.6224 49.1232 52.8344C49.0646 53.5386 48.4775 54.0813 47.7708 54.0845L40.8959 54.0818ZM50.4388 62.943C50.4388 66.3311 47.6922 69.0777 44.3041 69.0777C40.916 69.0777 38.1694 66.3311 38.1694 62.943C38.1694 59.5549 40.916 56.8083 44.3041 56.8083C47.6922 56.8083 50.4388 59.5549 50.4388 62.943Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruefalseKnob);
export default __webpack_public_path__ + "static/media/truefalse_knob.0a913b2f.svg";
export { ForwardRef as ReactComponent };